import React from "react";
import Centered from "./Centered";

export default function Loader({ children }: { children?: React.ReactNode }) {
  return <Centered>{children}</Centered>;
}
